import styled from 'styled-components';

export const WelcomeText = styled.h3`
  margin: 36px 0 0;
  color: ${(props) => props.theme.antd?.colorPrimary};
  font-size: 20px;
  font-weight: 600;
`;

export const CardTitle = styled.h5`
  margin: 16px 0 0;
  color: #78797d;
  font-size: 16px;
  font-weight: 500;
  line-height: 44px;
`;
